/**
 * Reglas de validacion compartidas por los formularios.
 *
 * Estaba escrita diez veces, una por modal de establecimiento (ALLOWED_CHARS_REGEX,
 * ALLOWED_CHARS_MESSAGE y sanitizeAlphanumeric), asi que cualquier ajuste se aplicaba en uno y
 * se olvidaba en los otros. Aca vive una sola vez.
 */

/**
 * Caracteres permitidos en los campos de texto libre (nombres, calles).
 *
 * Ademas de letras, numeros y espacios acepta: , . : - ( ) °
 *
 * La coma, los parentesis y el simbolo de grado se agregaron porque son habituales en nombres
 * reales: "Hospital Zonal Dr. Lopez Lima, Sede Central", "Puesto Sanitario N° 5",
 * "Posta (Ex Unidad Movil)". Antes esos nombres se rechazaban.
 *
 * Siguen fuera # @ / y comillas, que no aparecen en nombres reales y suelen indicar un dato
 * mal pegado.
 *
 * El guion va ULTIMO en la clase de caracteres a proposito: en cualquier otra posicion seria
 * un rango y la clase significaria otra cosa.
 */
const CARACTERES_PERMITIDOS = "a-zA-Z0-9À-ÿ\\s.,:()°-";

/**
 * La lista de caracteres se escribe UNA vez y de ahi salen las dos formas en que se usa: la
 * que valida el valor entero y la que limpia lo que se tipea. Antes eran dos literales
 * distintos —el regex del schema y el del sanitize— y era cuestion de tiempo que uno aceptara
 * algo que el otro borraba.
 */
export const CARACTERES_PERMITIDOS_REGEX = new RegExp(
    `^[${CARACTERES_PERMITIDOS}]*$`
);

export const CARACTERES_PERMITIDOS_MSG =
    "Solo se permiten letras, números, espacios y los signos , . : - ( ) °";

const NO_PERMITIDOS_REGEX = new RegExp(`[^${CARACTERES_PERMITIDOS}]`, "g");

/**
 * Saca del texto lo que el campo no acepta, para usar en el onChange.
 *
 * Es el complemento de la validacion, no su reemplazo: el schema sigue siendo el que decide si
 * el formulario se puede mandar. Esto solo evita que el usuario vea aparecer un caracter que
 * despues le va a dar error.
 */
export const sanitizarTexto = (valor) =>
    (valor ?? "").replace(NO_PERMITIDOS_REGEX, "");
